// Map configuration constants
export const FOLLOW_ZOOM = 18;
export const MAIN_COLOR = "#45d44f";
export const LANGUAGES = ['gb', 'pt', 'fr', 'de'];

// Google Maps configuration
export const MAP_ID = 'e825437c4a52a9e0';
export const MAP_CENTER = { lat: 32.6669272, lng: -17.0186841 };
export const MAP_INITIAL_ZOOM = 15;
export const MAP_INITIAL_TILT = 45;
export const MAP_MIN_ZOOM = 10;
export const MAP_MAX_ZOOM = 20;

// Map bounds (southwest and northeast corners)
export const MAP_BOUNDS = {
    southwest: { lat: 32.6632913, lng: -17.0191483 },
    northeast: { lat: 32.6636295, lng: -17.0197676 }
};

// KML Layer URL
// Set to null or empty string to disable KML layer loading
// The KML file must be:
// 1. Publicly accessible (no authentication required)
// 2. Have proper CORS headers
// 3. Be accessible via GET requests
// 4. Be under 3MB (raw) or 10MB (uncompressed)
export const KML_LAYER_URL = 'https://jf-quintagrande.pt/SITE/assets/mapa/path-quinta-grande-v2.kml';
// Alternative: Host locally in public folder and use: '/path-quinta-grande-v2.kml'

// Geolocation configuration
export const GEOLOCATION_OPTIONS = {
    enableHighAccuracy: true,
    maximumAge: 1000,
    timeout: 10000
};

// Debounce timing
export const DEBOUNCE_DELAY = 100;
export const SCROLL_DELAY = 100;